
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19 17V3a2 2 0 00-2-2H3a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2zM7.5 6a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 017.5 6zm8.5 9.5a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5v-.33c0-.108.036-.213.1-.3l2.37-3.17a.51.51 0 01.81 0l1 1.36a.5.5 0 00.79 0l2.29-2.88a.5.5 0 01.78 0l3.74 4.67c.071.091.11.204.11.32l.01.33zM21 5v14a2 2 0 01-2 2H5a2 2 0 002 2h12c2.21 0 4-1.79 4-4V7a2 2 0 00-2-2z","fill":"#95989A","fill-rule":"evenodd"}})])
          )
        }
      }
    